import { routes } from './routes';
import {
  ReportDetails,
  BriefingForm,
  ReportList,
  BriefingDetails,
  ProductSelection,
} from '../../screens';

export const nextRouter = [
  {
    path: routes.productSelection,
    component: ProductSelection,
  },
  {
    path: routes.briefingDetail,
    component: BriefingDetails,
  },
  {
    path: routes.newBriefingForm,
    component: BriefingForm,
    featureFlag: 'xts_new_briefing_form',
  },
  {
    path: routes.newReportList,
    component: ReportList,
  },
  {
    path: routes.newReportDetails,
    component: ReportDetails,
  },
];
